/**
 * Assertion function for type narrowing. Asserts that type is not undefined.
 */
export function assertIsDefined(value) {
  if (value === undefined) {
    throw new Error('value must be defined');
  }
}